import { useSelector } from 'react-redux';
import { getTitle } from 'features/page-model/ducks/get-model';

export const useFrontImageAlt = () => {
  const title = useSelector(getTitle);
  return `Фасад магазина ${title}`;
};
